<template>



    <div class="w-full">
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">


            <div v-if="!$page.props.canManageSettings" @click="clickRow"
                class="bg-yellow-100 text-yellow-800  border-yellow-300 sm:rounded-md px-4 py-5 sm:p-6 border mb-10 text-sm flex flex-col gap-y-4 cursor-pointer group">
                <div class="flex flex-row items-between gap-x-2">
                    <div class="flex flex-row items-center gap-x-2 flex-grow">
                        <InformationCircleIcon class="w-4 h-4 mr-2" />
                        This page is read-only: You need to be connected with an Administrator profile to change these
                        settings.
                    </div>
                    <div class="text-sm text-yellow-800 flex items-center gap-x-2 group-hover:underline">See admins
                        <ChevronRightIcon
                            :class="[expandInfo ? 'rotate-90' : '', 'w-5 h-5 transition-transform duration-300']" />
                    </div>
                </div>

                <transition name="expand" @enter="enter" @leave="leave" :css="!fixed">
                    <div v-if="expandInfo" class="flex flex-row items-center gap-x-2 pl-8">
                        <ul>
                            <li v-for="admin in admins" :key="admin.email" class="py-1">
                                <a class="text-yellow-800 underline hover:text-yellow-900 text-sm"
                                    :href="'mailto:' + admin.email" title="send an email">{{ admin.name }}</a>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>



            <div>

                <div class="md:grid md:grid-cols-3 md:gap-6">

                    <div v-if="false" class="md:col-span-1">
                        <div class="px-4 sm:px-0 sticky self-start top-44">
                            <h3 class="text-lg font-medium text-gray-900">
                                Helpdesk
                            </h3>
                            <p class="mt-1 text-sm text-gray-700">
                                Which helpdesk do you want Birdie to integrate with?
                            </p>
                        </div>
                    </div>


                    <div class="mt-5 md:mt-0 col-span-3 text-sm">

                        <integrations-detail :integrations="integrations" :is_modal="false"
                            :zendesk_snippet="zendesk_snippet" :zendesk_autoreply="zendesk_autoreply"
                            :freshdesk_snippet="freshdesk_snippet" :freshdesk_autoreply="freshdesk_autoreply"
                            :happyfox_snippet="happyfox_snippet" :helpscout_autoreply="helpscout_autoreply"
                            :zendesk_snippet_installed="zendesk_snippet_installed" :integration_bank="integration_bank"
                            :initial_universal_recorders="initial_universal_recorders"
                            :hubspot_snippet="hubspot_snippet" />

                    </div>



                </div>

            </div>

        </div>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import IntegrationsDetail from '@/Components/Settings/IntegrationsDetail'

import { InformationCircleIcon, ChevronRightIcon } from "@heroicons/vue/16/solid"


export default {
    props: ["integrations", "zendesk_snippet", "zendesk_autoreply",
        "freshdesk_snippet", "freshdesk_autoreply", "happyfox_snippet", "zendesk_snippet_installed",
        "helpscout_autoreply",
        'integration_bank',
        'initial_universal_recorders', 'admins', 'hubspot_snippet'],
    components: {
        IntegrationsDetail, InformationCircleIcon, ChevronRightIcon
    },
    layout: AppLayout,
    data() {
        return {
            expandInfo: false,
        }
    },
    created() {
    },
    beforeUnmount() {
    },
    mounted() {
    },
    methods: {
        clickRow: function () {
            this.expandInfo = !this.expandInfo
        },
        enter(element) {
            const width = getComputedStyle(element).width;
            element.style.width = width;
            element.style.position = 'absolute';
            element.style.visibility = 'hidden';
            element.style.height = 'auto';

            const height = getComputedStyle(element).height;
            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = height;
        },

        leave(element) {

            const height = getComputedStyle(element).height;
            element.style.height = height;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = 0;
        }
    },

}
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
    transition: height 0.3s ease-in-out;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    height: 0;
}
</style>
